import { noChange as i, nothing as o } from "../beacon-html.d/index.js";
import { directive as a, Directive as T, PartType as r } from "../beacon-directive.d/index.js";
import { isSingleExpression as l, setCommittedValue as p } from "../beacon-directive-helpers.d/index.js";
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const m = a(class extends T {
  constructor(e) {
    if (super(e), e.type !== r.PROPERTY && e.type !== r.ATTRIBUTE && e.type !== r.BOOLEAN_ATTRIBUTE)
      throw Error("The `live` directive is not allowed on child or event bindings");
    if (!l(e))
      throw Error("`live` bindings can only contain a single expression");
  }
  render(e) {
    return e;
  }
  update(e, [t]) {
    if (t === i || t === o)
      return t;
    const n = e.element, s = e.name;
    if (e.type === r.PROPERTY) {
      if (t === n[s])
        return i;
    } else if (e.type === r.BOOLEAN_ATTRIBUTE) {
      if (!!t === n.hasAttribute(s))
        return i;
    } else if (e.type === r.ATTRIBUTE && n.getAttribute(s) === t + "")
      return i;
    return p(e), t;
  }
});
export {
  m as live
};
